module.exports = __webpack_public_path__ + "static/media/java.ca3dadf0.jpg";